import { DeliveryType } from './type'
import Visual from './Visual'

const Delivery = ({ shipping, services }: DeliveryType) => {
  return <Visual shipping={shipping} services={services}/>
}

export default Delivery
